module.exports = __webpack_public_path__ + "media/images/member_announce-c8f25cab5abf7ce135b1fc3b7a2944ee.svg";